/**
 * Токены бренда KODE — выверены по CSS-бандлам kode.ru.
 *
 * Эти же значения продублированы в src/index.css как CSS-переменные: MUI v4
 * строит тему на JSS и не умеет разрешать var() внутри fade()/палитры, а
 * не-MUI слои (эффекты, Welcome) должны читать те же цвета. Держать оба
 * списка синхронными — они помечены одинаковыми именами.
 */

export const DRAWER_WIDTH = 272;

// Gilroy коммерческий и в закрытый контур его не принести; Manrope 800 —
// ближайшая свободная замена геометрического Extrabold. Всё заведено через
// один токен: лицензионный Gilroy меняется двумя файлами и этой строкой.
const SYSTEM_FALLBACK =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
export const FONT_DISPLAY = `'Manrope', 'Montserrat', ${SYSTEM_FALLBACK}`;
export const FONT_BODY = `'Montserrat', ${SYSTEM_FALLBACK}`;
export const FONT_MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";

export const ACCENT = "#4f4ff4";
export const ACCENT_HOVER = "#6563ff";
export const ACCENT_ACTIVE = "#4141ca";
// Акцент на чёрном даёт 3.76:1 — годится от 20px/600 и для границ, но не для
// мелкого текста. Ниже этого порога берём accent-2 (5.68:1).
export const ACCENT_TEXT = "#5c7aff";

export const STATUS_OK = "#00c853";
export const STATUS_WARN = "#ffae22";
export const STATUS_ERR = "#e6212d";

// Радиусы KODE маленькие и разные по ролям — это не «таблеточный» бренд.
export const RADIUS_CTA = 2;
export const RADIUS_INPUT = 4;
export const RADIUS_PANEL = 8;

export const EASE_SPRING = "cubic-bezier(.49,.29,.18,1.17)";
export const EASE_OUT = "cubic-bezier(.4,0,.2,1)";

export const darkSurfaces = {
  bg: "#000000",
  surface1: "#111111",
  surface2: "#0a0a0a",
  surface3: "#1a1a1a",
  hairline: "rgba(255,255,255,0.12)",
  hairlineStrong: "rgba(255,255,255,0.24)",
  glass: "rgba(255,255,255,0.10)",
  fg: "#ffffff",
  fgDim: "rgba(255,255,255,0.50)",
  fgMuted: "#797979",
  scrim: "rgba(0,0,0,0.72)",
};

export const lightSurfaces = {
  bg: "#f4f4f5",
  surface1: "#ffffff",
  surface2: "#fafafa",
  surface3: "#ececee",
  hairline: "rgba(0,0,0,0.12)",
  hairlineStrong: "rgba(0,0,0,0.24)",
  glass: "rgba(255,255,255,0.72)",
  fg: "#0a0a0a",
  fgDim: "rgba(0,0,0,0.55)",
  fgMuted: "#6b6b6b",
  scrim: "rgba(0,0,0,0.45)",
};
